import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-el-icon-success",
  "use": "icon-el-icon-success-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18 18\" id=\"icon-el-icon-success\">\r\n    <path id=\"icon-el-icon-success_check-circle-filled\" fill-rule=\"evenodd\" transform=\"translate(1.125 1.125)  rotate(0 7.875 7.875)\" opacity=\"1\" d=\"M7.88 0C3.53 0 0 3.53 0 7.88C0 12.22 3.53 15.75 7.88 15.75C12.22 15.75 15.75 12.22 15.75 7.88C15.75 3.53 12.22 0 7.88 0Z M11.81 5.86L11.02 5.06L6.75 9.33L4.73 7.31L3.94 8.11L6.75 10.92L11.81 5.86Z \" />\r\n\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol